import { ROTULO_ORIGEM_LUCRO, type OrigemLucro as Origem } from '@triade/contracts';
import { cn } from '@/lib/utils';

/** Texto da origem da meta e do minimo de lucro (DP6): "Meta e mínimo: da tabela" ou, se diferem, cada um. */
export function textoOrigem(desejado: Origem, minimo: Origem): string {
  return desejado === minimo
    ? `Meta e mínimo: ${ROTULO_ORIGEM_LUCRO[desejado]}`
    : `Meta: ${ROTULO_ORIGEM_LUCRO[desejado]} · mínimo: ${ROTULO_ORIGEM_LUCRO[minimo]}`;
}

const CURTO: Record<Origem, string> = { TABELA: 'tabela', EMPRESA: 'empresa', AUSENTE: 'sem padrão' };

/** Forma curta para celula de grade: igual nos dois = "da tabela" / "padrão da empresa"; senao "meta: tabela · mín.: empresa". */
export function textoOrigemCurto(desejado: Origem, minimo: Origem): string {
  return desejado === minimo ? ROTULO_ORIGEM_LUCRO[desejado] : `meta: ${CURTO[desejado]} · mín.: ${CURTO[minimo]}`;
}

export interface OrigemLucroProps {
  desejado: Origem | undefined;
  minimo: Origem | undefined;
  className?: string;
  /** Celula de grade: texto curto (o completo fica no `title`). */
  compacto?: boolean;
}

/**
 * De onde vieram a meta e o minimo de lucro que a API entregou ao motor: "da tabela" ou "padrão da empresa" (Empresa >
 * Parametros). So texto: o valor e a origem chegam resolvidos da API. Sem origem (resposta antiga), nao mostra nada.
 */
export function OrigemLucro({ desejado, minimo, className, compacto = false }: OrigemLucroProps) {
  if (!desejado || !minimo) return null;
  const completo = textoOrigem(desejado, minimo);
  return (
    <span data-testid="origem-lucro" title={completo} className={cn('text-caption text-ink-muted', className)}>
      {compacto ? textoOrigemCurto(desejado, minimo) : completo}
    </span>
  );
}
